import _ from 'lodash';

export const RESET_REVIEWING_REPORT = "[MRT] RESET_REVIEWING_REPORT";

export const VIEW_WORKLIST_VISIT = "[MRT] VIEW_WORKLIST_VISIT";
export const VIEW_WORKLIST_VISIT_START = "[MRT] VIEW_WORKLIST_VISIT_START";
export const VIEW_WORKLIST_VISIT_SUCCESS = "[MRT] VIEW_WORKLIST_VISIT_SUCCESS";
export const VIEW_WORKLIST_VISIT_ERROR = "[MRT] VIEW_WORKLIST_VISIT_ERROR";

export const VIEW_REVIEW_PENDING_REPORT = "[MRT] VIEW_REVIEW_PENDING_REPORT";
export const VIEW_REVIEW_PENDING_REPORT_START = "[MRT] VIEW_REVIEW_PENDING_REPORT_START";
export const VIEW_REVIEW_PENDING_REPORT_SUCCESS = "[MRT] VIEW_REVIEW_PENDING_REPORT_SUCCESS";
export const VIEW_REVIEW_PENDING_REPORT_ERROR = "[MRT] VIEW_REVIEW_PENDING_REPORT_ERROR";

export const VIEW_SUBMITTED_TO_TYPIST_VISIT = "[MRT] VIEW_SUBMITTED_TO_TYPIST_VISIT";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_START = "[MRT] VIEW_SUBMITTED_TO_TYPIST_VISIT_START";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS = "[MRT] VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR = "[MRT] VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR";

export const VIEW_HISTORY_REPORT = "[MRT] VIEW_HISTORY_REPORT";
export const VIEW_HISTORY_REPORT_START = "[MRT] VIEW_HISTORY_REPORT_START";
export const VIEW_HISTORY_REPORT_SUCCESS = "[MRT] VIEW_HISTORY_REPORT_SUCCESS";
export const VIEW_HISTORY_REPORT_ERROR = "[MRT] VIEW_HISTORY_REPORT_ERROR";

export const UNLOCK_VISIT = "[MRT] UNLOCK_VISIT";
export const UNLOCK_VISIT_SUCCESS = "[MRT] UNLOCK_VISIT_SUCCESS";
export const UNLOCK_VISIT_ERROR = "[MRT] UNLOCK_VISIT_ERROR";
export const UNLOCK_VISIT_START = "[MRT] UNLOCK_VISIT_START";

export const UPDATE_REVIEWING_REPORT_STATUS = "[MRT] UPDATE_REVIEWING_REPORT_STATUS";
export const UPDATE_REVIEWING_REPORT_STATUS_START = "[MRT] UPDATE_REVIEWING_REPORT_STATUS_START";
export const UPDATE_REVIEWING_REPORT_STATUS_SUCCESS = "[MRT] UPDATE_REVIEWING_REPORT_STATUS_SUCCESS";
export const UPDATE_REVIEWING_REPORT_STATUS_ERROR = "[MRT] UPDATE_REVIEWING_REPORT_STATUS_ERROR";

export const FETCH_PATIENT_HISTORY_REPORTS = "[MRT] FETCH_PATIENT_HISTORY_REPORTS";
export const FETCH_PATIENT_HISTORY_REPORTS_START = "[MRT] FETCH_PATIENT_HISTORY_REPORTS_START";
export const FETCH_PATIENT_HISTORY_REPORTS_SUCCESS = "[MRT] FETCH_PATIENT_HISTORY_REPORTS_SUCCESS";
export const FETCH_PATIENT_HISTORY_REPORTS_ERROR = "[MRT] FETCH_PATIENT_HISTORY_REPORTS_ERROR";

export const UPDATE_TICKET_ID = "[MRT] UPDATE_TICKET_ID";

export const SAVE_VISIT_REPORT_DICTATION = "[MRT] SAVE_VISIT_REPORT_DICTATION";
export const SAVE_VISIT_REPORT_DICTATION_SUCCESS = "[MRT] SAVE_VISIT_REPORT_DICTATION_SUCCESS";
export const SUBMIT_VISIT_REPORT_DICTATION = "[MRT] SUBMIT_VISIT_REPORT_DICTATION";
export const SUBMIT_VISIT_REPORT_DICTATION_SUCCESS = "[MRT] SUBMIT_VISIT_REPORT_DICTATION_SUCCESS";
export const SKIP_CURRENT_AND_VIEW_NEXT_VISIT = "[MRT] SKIP_CURRENT_AND_VIEW_NEXT_VISIT";

export const VIEW_PARKED_VISIT = "[MRT] VIEW_PARKED_VISIT";
export const VIEW_PARKED_VISIT_START = "[MRT] VIEW_PARKED_VISIT_START";
export const VIEW_PARKED_VISIT_SUCCESS = "[MRT] VIEW_PARKED_VISIT_SUCCESS";
export const VIEW_PARKED_VISIT_ERROR = "[MRT] VIEW_PARKED_VISIT_ERROR";

export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT = "[MRT] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START = "[MRT] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS = "[MRT] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR = "[MRT] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR";

export const VIEW_VERIFIED_VISIT = "[MRT] VIEW_VERIFIED_VISIT"
export const VIEW_VERIFIED_VISIT_START = "[MRT] VIEW_VERIFIED_VISIT_START"
export const VIEW_VERIFIED_VISIT_SUCCESS = "[MRT] VIEW_VERIFIED_VISIT_SUCCESS"
export const VIEW_VERIFIED_VISIT_ERROR = "[MRT] VIEW_VERIFIED_VISIT_ERROR"

export const UPDATE_VISIT_REPORT_STATE = "[MRT] UPDATE_VISIT_REPORT_STATE";
export const UPDATE_VISIT_REPORT_STATE_START = "[MRT] UPDATE_VISIT_REPORT_STATE_START";
export const UPDATE_VISIT_REPORT_STATE_SUCCESS = "[MRT] UPDATE_VISIT_REPORT_STATE_SUCCESS";
export const UPDATE_VISIT_REPORT_STATE_ERROR = "[MRT] UPDATE_VISIT_REPORT_STATE_ERROR";

export const UPDATE_STUDY = "[MRT] UPDATE_STUDY";
export const UPDATE_STUDY_SUCCESS = "[MRT] UPDATE_STUDY_SUCCESS";
export const UPDATE_STUDY_ERROR = "[MRT] UPDATE_STUDY_ERROR";

export const viewWorklistVisit = (report) => {
    return {
        type: VIEW_WORKLIST_VISIT,
        report
    };
};

export const viewSubmittedForVerificationVisit = (report) => {
    return {
        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT,
        report
    };
};

export const viewParkedVisit = (report) => {
    return {
        type: VIEW_PARKED_VISIT,
        report
    };
};

export const viewSubmittedToTypistVisit = (report) => {
    return {
        type: VIEW_SUBMITTED_TO_TYPIST_VISIT,
        report
    };
};

export const viewVerifiedVisit = (visit) => {
    return {
        type: VIEW_VERIFIED_VISIT,
        visit
    };
};

export const viewHistoryReport = (report) => {
    return {
        type: VIEW_HISTORY_REPORT,
        report
    };
};

export const resetReviewingReport = () => {
    return {
        type: RESET_REVIEWING_REPORT,
    };
}

export const updateVisitReportState = (updateReportData, autoNextConfig) => {
    return {
        type: UPDATE_VISIT_REPORT_STATE,
        payload: {
            updateReportData,
            autoNextConfig
        },
    };
}

export const fetchPatientHistoryReports = (visit) => {
    return {
        type: FETCH_PATIENT_HISTORY_REPORTS,
        visit,
    };
}

export const unlockVisit = (visit, onConfirm) => {
    return {
        type: UNLOCK_VISIT,
        payload: {
            visit,
            onConfirm
        }
    };
}

export const submitVisitReportDictation = (dictation, autoNextConfig) => {
    return {
        type: SUBMIT_VISIT_REPORT_DICTATION,
        payload: {
            dictation,
            autoNextConfig
        }
    }
}

export const skipCurrentAndLoadNextVisit = (visit, autoNextConfig) => {
    return {
        type: SKIP_CURRENT_AND_VIEW_NEXT_VISIT,
        payload: {
            visit,
            autoNextConfig
        }
    }
}

export const updateMrtStudy = (payload) => {
    return {
        type: UPDATE_STUDY,
        payload
    };
}

export const ADD_REPORT_DIAGRAM_SUCCESS = "[MRT] ADD_REPORT_DIAGRAM_SUCCESS";

export const addReportDiagram = (diagram) => {
    return {
        type: ADD_REPORT_DIAGRAM_SUCCESS,
        'diagram': diagram
    }
}